export const testimonialContentData = {
	heading: "Happy Customers",
	description: "Read what our customers have to say about us.",
	customers: [
		{
			id: 1,
			src: "/images/customerProfileImages/img(1).jpg",
			name: "John Doe",
			job: "Software Engineer",
			description:
				"The service provided was exceptional. I felt very comfortable and well taken care of from the moment I walked in. The staff were friendly and attentive, ensuring all my needs were met.",
		},
		{
			id: 2,
			src: "/images/customerProfileImages/img(2).jpg",
			name: "Jane Smith",
			job: "Project Manager",
			description:
				"The team was very helpful and supportive throughout the entire process. I am very grateful for the outstanding customer service and the extra effort they put in to make sure I was satisfied.",
		},
		{
			id: 3,
			src: "/images/customerProfileImages/img(3).jpg",
			name: "Alice Johnson",
			job: "Graphic Designer",
			description:
				"Fantastic experience, will come back again! The quality of service was excellent and the staff were incredibly friendly and professional. Highly recommend to anyone looking for top-notch service.",
		},
		{
			id: 4,
			src: "/images/customerProfileImages/img(4).jpg",
			name: "Robert Brown",
			job: "Marketing Specialist",
			description:
				"Exceeded my expectations in every way. The staff were professional, courteous, and attentive to my needs. The entire experience was smooth and enjoyable. I will definitely be returning.",
		},
		{
			id: 5,
			src: "/images/customerProfileImages/img(5).jpg",
			name: "Emma Wilson",
			job: "HR Manager",
			description:
				"Truly professional and courteous service. I felt valued as a customer and appreciated the attention to detail. The staff went above and beyond to ensure my satisfaction. Highly recommended!",
		},
		{
			id: 6,
			src: "/images/customerProfileImages/img(6).jpg",
			name: "Michael Davis",
			job: "Accountant",
			description:
				"Very pleased with the service received. The staff were knowledgeable and friendly, providing excellent customer service. I would highly recommend them to anyone seeking high-quality service.",
		},
		{
			id: 7,
			src: "/images/customerProfileImages/img(7).jpg",
			name: "Sophia Martinez",
			job: "Customer Support Specialist",
			description:
				"I felt valued and appreciated throughout my entire visit. The staff were attentive, kind, and professional, making sure all my needs were met. It was a truly outstanding experience.",
		},
		{
			id: 8,
			src: "/images/customerProfileImages/img(8).jpg",
			name: "William Garcia",
			job: "Sales Manager",
			description:
				"Top-notch service from start to finish. The staff were very accommodating and went out of their way to make sure I was comfortable. I couldn't have asked for a better experience.",
		},
		{
			id: 9,
			src: "/images/customerProfileImages/img(9).jpg",
			name: "Isabella Rodriguez",
			job: "Content Writer",
			description:
				"Customer service was excellent. The staff were friendly, professional, and attentive to all my needs. I felt well taken care of and would highly recommend their services to anyone.",
		},
		{
			id: 10,
			src: "/images/customerProfileImages/img(10).jpg",
			name: "James Lee",
			job: "Data Analyst",
			description:
				"Wonderful experience overall. The service provided was of the highest quality and the staff were incredibly friendly and professional. I would definitely recommend their services to others.",
		},
	],
};
